import { DialogData } from './../models/dialog.model';
import { SnackbarData } from './../models/snackbar.model';
import { createAction, props } from '@ngrx/store';

import { PageActions, PageMenuItem } from '../models/page.model';

export const setMenuItems = createAction(
  PageActions.LOAD_MENU_ITEMS,
  props<{ items: PageMenuItem[] }>()
);

export const setBannerComponent = createAction(
  PageActions.SET_BANNER_COMPONENT,
  props<{ banner: any; subtitle?: string }>()
);

export const navigateTo = createAction(
  PageActions.NAVIGATE_TO,
  props<{ route: string }>()
);

export const openDialog = createAction(
  PageActions.OPEN_DIALOG,
  props<{ dialogData: DialogData }>()
);

export const closeDialog = createAction(PageActions.CLOSE_DIALOG);

export const openSnackbar = createAction(
  PageActions.OPEN_SNACKBAR,
  props<{ snackbarData: SnackbarData }>()
);

export const closeSnackbar = createAction(PageActions.CLOSE_SNACKBAR);
